<template>
  <div style="position: relative">

    <Navber :getIndex="tab"></Navber>
    <AppMain></AppMain>
    <AppFooter @getTab="getTab"></AppFooter>

  </div>
</template>

<script>
    import Navber from "./components/Navber";
    import AppMain from "./components/AppMain";
    import AppFooter from "./components/AppFooter";

    export default {
        name: "Layout",
        inject: ['reload'],
        data() {
            return {
                tab: 0
            }
        },
        components: {Navber, AppMain, AppFooter},
        methods: {
            getTab(index) {
                this.tab = index;
                console.log(index)
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue